import { SHStack, SHStackProps } from "@components/design-systems";
import SHSkeleton, {
  SHSkeletonProps,
} from "@components/design-systems/sh-skeleton";

type TransferSelectFeatureListSkeletonProps = SHStackProps & {
  skeletonProps?: SHSkeletonProps;
};
export const TransferSelectFeatureListSkeleton = ({
  skeletonProps,
  ...others
}: TransferSelectFeatureListSkeletonProps) => {
  return (
    <SHStack
      direction="row"
      justifyContent="space-between"
      alignItems={"flex-start"}
      gap="25px"
      {...others}
    >
      <SHStack
        width={"50%"}
        direction={"column"}
        sx={{
          gap: "10px",
        }}
      >
        {Array.from(Array(5).keys()).map((index) => (
          <SHSkeleton
            key={index}
            width={"100%"}
            height={"50px"}
            {...skeletonProps}
          />
        ))}
      </SHStack>
      <SHStack
        width={"50%"}
        direction={"column"}
        sx={{
          gap: "10px",
        }}
      >
        {Array.from(Array(5).keys()).map((index) => (
          <SHSkeleton
            key={index}
            width={"100%"}
            height={"50px"}
            {...skeletonProps}
          />
        ))}
      </SHStack>
    </SHStack>
  );
};
